import { render, staticRenderFns } from "./DenunciaTabelaGestao.vue?vue&type=template&id=15e4336d&lang=pug"
import script from "./DenunciaTabelaGestao.vue?vue&type=script&lang=js"
export * from "./DenunciaTabelaGestao.vue?vue&type=script&lang=js"
import style0 from "./DenunciaTabelaGestao.vue?vue&type=style&index=0&id=15e4336d&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports